var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmWhiteEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257.36 57.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #040000;\n      }\n\n      .cls-2 {\n        fill: #6a6e77;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "222.33 41.14 222.33 57.03 237.24 57.03 237.24 53.39 226.56 53.39 226.56 44.78 237.24 44.78 237.24 41.14 222.33 41.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 228.67,
    y: 47.31,
    width: 8.57,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 196.13,
    y: 41.14,
    width: 4.23,
    height: 15.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 156.44,
    y: 41.14,
    width: 4.23,
    height: 15.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.66,41.14h-6.55l-6.8,15.89h4.67l1.3-3.22h8.19l1.3,3.22h4.67l-6.8-15.89ZM184.79,44.67l2.3,5.69h-5.4l2.3-5.69h.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "173.39 57.03 167.39 57.03 161.35 50.09 167.21 50.09 173.39 57.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "173.39 41.14 167.39 41.14 161.35 48.08 167.21 48.08 173.39 41.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.36,57.03l-3.96-5.59c2.01-.76,3.43-2.7,3.43-4.98h0c0-2.94-2.38-5.32-5.32-5.32h-11.09v15.89h4.23v-5.25h4.17l3.46,5.25h5.08ZM244.65,44.86h6.18c.98,0,1.77.79,1.77,1.77s-.79,1.77-1.77,1.77h-6.18v-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.61,41.14v15.89h4.23v-4.93h6.7c3.03,0,5.48-2.45,5.48-5.48h0c0-3.03-2.45-5.48-5.48-5.48h-10.93ZM207.83,48.37v-3.52h6.2c.97,0,1.76.79,1.76,1.76h0c0,.97-.79,1.76-1.76,1.76h-6.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.87,31.56h-10.33c-4.96,0-8.99-4.03-8.99-8.99v-13.8h5.08v13.8c0,2.16,1.75,3.91,3.91,3.91h5.25V8.76h5.08v22.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.63,31.6h-5.08v-13.8c0-2.16-1.75-3.91-3.91-3.91h-5.25v17.71h-5.08V8.81h10.33c4.96,0,8.99,4.03,8.99,8.99v13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.4,31.79c-6.39,0-11.58-5.2-11.58-11.58s5.2-11.58,11.58-11.58,11.58,5.2,11.58,11.58-5.2,11.58-11.58,11.58ZM200.4,13.71c-3.58,0-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5,6.5-2.91,6.5-6.5-2.92-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.12,31.79c-6.39,0-11.58-5.2-11.58-11.58s5.2-11.58,11.58-11.58,11.58,5.2,11.58,11.58-5.2,11.58-11.58,11.58ZM117.12,13.71c-3.58,0-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5,6.5-2.91,6.5-6.5-2.92-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.94,
    width: 5.35,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 180.28,
    y: 8.57,
    width: 5.35,
    height: 23.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 182.93,
    cy: 3.51,
    r: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.97,13.71v-5.08h-6.67V3.06h-5.08v20.44c0,4.44,3.61,8.05,8.05,8.05h3.7v-5.08h-3.7c-1.64,0-2.97-1.33-2.97-2.97v-9.8h6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.56,31.79h-11.37v-5.08h11.37c.93,0,1.69-.76,1.69-1.69,0-1.05-.88-2.2-1.69-2.2h-4.67c-4.19,0-7.35-2.94-7.35-6.84s3.3-7.35,7.35-7.35h10.74v5.08h-10.74c-1.25,0-2.27,1.02-2.27,2.27,0,1.67,1.89,1.75,2.27,1.75h4.67c3.61,0,6.77,3.41,6.77,7.29s-3.04,6.77-6.77,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.74,31.56h-11.25v-5.08h11.25c1.99,0,4.11-1.01,4.11-2.87,0-1.63-1.1-3.05-2.67-3.47l-7.13-1.77c-3.62-.96-6.12-4.22-6.12-7.92,0-4.51,3.67-8.18,8.18-8.18h12.16v5.08h-12.16c-1.71,0-3.1,1.39-3.1,3.1,0,1.4.95,2.63,2.3,2.99l7.13,1.77c3.84,1.02,6.49,4.47,6.49,8.4,0,4.54-3.95,7.96-9.19,7.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.22,31.64h-7.64c-8.11,0-14.71-6.6-14.71-14.71s6.6-14.71,14.71-14.71h7.64v5.08h-7.64c-5.31,0-9.63,4.32-9.63,9.63s4.32,9.63,9.63,9.63h7.64v5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.6,31.64h-8.33c-8.11,0-14.71-6.6-14.71-14.71s6.6-14.71,14.71-14.71h8.44v5.08h-8.44c-5.31,0-9.63,4.32-9.63,9.63s4.32,9.63,9.63,9.63h3.25v-9.74h5.08v14.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.81,31.56H.56v-5.08h11.25c1.99,0,4.11-1.01,4.11-2.87,0-1.63-1.1-3.06-2.67-3.47l-7.13-1.77c-3.62-.97-6.12-4.22-6.12-7.92C0,5.94,3.67,2.27,8.18,2.27h12.15v5.08h-12.15c-1.71,0-3.1,1.39-3.1,3.1,0,1.4.95,2.63,2.3,2.99l7.13,1.77c3.84,1.02,6.49,4.47,6.49,8.4,0,4.54-3.95,7.96-9.19,7.96Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmWhiteEn);
export default __webpack_public_path__ + "static/media/logo_sm_white_en.d59ae8d8f028ccae9d30798a7c28fe46.svg";
export { ForwardRef as ReactComponent };